<template xmlns="http://www.w3.org/1999/html">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12" >
        <div class="alert alert-warning" v-if="Object.keys(comparison).length > 0">
          {{ __("forms.mboSimulation.plansComparisons") }} {{comparison.comparisonPlanName}}
        </div>
        <label v-if=" sync_url!== ''  && !isReady">
          <i  class="fa-solid fa-sync fa-spin"></i>
          <label>{{ __("misc.synchronizing") }}</label>
        </label>
      </div>
    </div>
    <div class="mt-3" style="overflow-x: auto; white-space: nowrap; display: flex; padding-bottom: 10px; justify-content: space-between;">
      <div class="" style="flex: 0 0 100px; display: inline-block; margin-right: 10px;">
        <div class="card border-card px-3 py-1" >
          <p class="small colored-icon">
            Ʃ {{ __("forms.EvaluationChart.questions.questions_setting.question12.tableKPI.bonus_target") }}
          </p>
          <p class="small">
              <label v-if="isReady">

                <label v-if="Object.keys(comparison).length > 0 && comparison.bonusTarget > 0 " style="color: #2A9D8F;font-size: 12px">
                    + {{comparison.bonusTargetEnchanted}}%
                </label>
                <label v-if="Object.keys(comparison).length > 0 && comparison.bonusTarget < 0 " style="color: #F04649;font-size: 12px">
                {{comparison.bonusTargetEnchanted}}%
                </label>

                {{ bonusTarget }} €
              </label>
              <label v-else>
                - €
              </label>
          </p>
        </div>
      </div>
      <div class="" style="flex: 0 0 100px; display: inline-block; margin-right: 10px;">
        <div class="card border-card px-3 py-1">
          <p class="small colored-icon">
            Ʃ {{ __("forms.EvaluationChart.questions.questions_setting.question12.tableKPI.bonus_weight") }}
          </p>
          <p class="small">
            <label v-if="isReady">

              <label v-if="Object.keys(comparison).length > 0 && comparison.bonusWeight > 0 " style="color: #2A9D8F;font-size: 12px">
                + {{comparison.bonusWeightEnchanted}}%
              </label>
              <label v-if="Object.keys(comparison).length > 0 && comparison.bonusWeight < 0 " style="color: #F04649;font-size: 12px">
                {{comparison.bonusWeightEnchanted}}%
              </label>
              {{ bonusWeight }} €
            </label>
            <label v-else>
              - €
            </label>
          </p>
        </div>
      </div>
      <div class="" style="flex: 0 0 100px; display: inline-block; margin-right: 10px;">
        <div class="card border-card px-3 py-1">
          <p class="small colored-icon">
            Ʃ {{ __("forms.EvaluationChart.questions.questions_setting.question12.tableKPI.bonus_rep") }}
          </p>
          <p class="small">

            <label v-if="isReady">
              <label v-if="Object.keys(comparison).length > 0 && comparison.bonusRep > 0 " style="color: #2A9D8F;font-size: 12px">
                + {{comparison.bonusRepEnchanted}}%
              </label>
              <label v-if="Object.keys(comparison).length > 0 && comparison.bonusRep < 0 " style="color: #F04649;font-size: 12px">
                {{comparison.bonusRepEnchanted}}%
              </label>
              {{ bonusRep }} €
            </label>
            <label v-else>
              - €
            </label>
          </p>
        </div>
      </div>
      <div class="" style="flex: 0 0 100px; display: inline-block; margin-right: 10px;">
        <div class="card border-card px-3 py-1">
          <p class="small colored-icon">
            {{ __("forms.EvaluationChart.questions.questions_setting.question12.tableKPI.avg_percent_prize") }}
          </p>
          <p class="small">
            <label v-if="isReady">
              <label v-if="Object.keys(comparison).length > 0 && comparison.avgPercentPrize > 0 " style="color: #2A9D8F;font-size: 12px">
                 + {{comparison.avgPercentPrizeEnchanted}}%
              </label>
              <label v-if="Object.keys(comparison).length > 0 && comparison.avgPercentPrize < 0 " style="color: #F04649;font-size: 12px">
                 {{comparison.avgPercentPrizeEnchanted}}%
              </label>
              {{ avgPercentPrize }} %
            </label>
            <label v-else>
              - %
            </label>
          </p>
        </div>
      </div>
      <div class="" style="flex: 0 0 100px; display: inline-block; margin-right: 10px;">
        <div class="card border-card px-3 py-1">
          <p class="small colored-icon">
            {{ __("forms.mbo.thesholdIntern") }}
          </p>
          <p class="small">
            <label v-if="isReady">
              {{ avgThresholds }} %
            </label>
            <label v-else>
              - %
            </label>
          </p>
        </div>
      </div>


    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isReady : false,
      onSync : false,

      bonusTarget : 0.0,
      bonusWeight : 0.0,
      bonusRep : 0.0,
      bonusNotAssigned : 0.0,
      avgThresholds : 0.0,
      avgPercentPrize : 0.0,
      comparison : {},

      lastIndexApiUrl : null,
      lastFilterData : null,


    };
  },
  props: {
    sync_url: {
      type: String,
      required: false,
      default : ""
    },
    comparison_incentive_plan_id: {
      type: Number,
      required: false,
      default : 0
    },

  },
  methods: {

    syncCache(){

      this.isReady = false;
      axios.get(this.sync_url).then((response) => {

          this.refreshData(this.lastIndexApiUrl,this.lastFilterData);
          this.refreshTablesPeopleKpi();
      }).catch();

    },

    refreshData(indexApiUrl,filterData) {

        filterData['comparison_incentive_plan_id'] = this.comparison_incentive_plan_id;
        this.lastFilterData = filterData;
        this.lastIndexApiUrl = indexApiUrl;

        this.isReady = false;
        axios.get(indexApiUrl+"/summary",{ params: filterData })
            .then((response) => {
              let arrayResult = response.data;

              this.bonusTarget = arrayResult.bonusTargetEnchanted;
              this.bonusWeight = arrayResult.bonusWeightEnchanted;
              this.bonusRep = arrayResult.bonusRepEnchanted;
              this.bonusNotAssigned = arrayResult.bonusNotAssignedEnchanted;
              this.avgThresholds = arrayResult.avgThresholds;
              this.avgPercentPrize = arrayResult.avgPercentPrize;
              this.comparison = arrayResult.comparison;

              this.isReady = true;
            }).catch(function(error){
          console.error(error);
        });
    },
    refreshTablesPeopleKpi(){
      app.__vue__.$refs.peopleKpi_approved_vuetable.refreshTableFromOutside();
      app.__vue__.$refs.peopleKpi_not_approved_vuetable.refreshTableFromOutside();
      app.__vue__.$refs.just_kpi_approved_vuetable.refreshTableFromOutside();
      app.__vue__.$refs.just_kpi_not_approved_vuetable.refreshTableFromOutside();

    }
    
  },
};
</script>

<style>

</style>
<script setup>
</script>